import { render, staticRenderFns } from "./BranchsKamsModal.vue?vue&type=template&id=7056d186"
import script from "./BranchsKamsModal.vue?vue&type=script&lang=js"
export * from "./BranchsKamsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports